import { Col, Row } from 'react-bootstrap';

import { type DOIParticipant } from '../utils/doi';
import orcid from './orcid.png';

export function UsersList({
  users,
  title,
}: {
  users?: DOIParticipant[];
  title?: string;
}) {
  if (!users?.length) {
    return null;
  }

  return (
    <Col xs={12}>
      <Row className="gx-2">
        {title && (
          <Col xs="auto">
            <small>{title}:</small>
          </Col>
        )}
        {users.map((participant, index, self) => (
          <Col xs="auto" key={participant.name}>
            <span>
              <small className="text-muted text-nowrap">
                {participant.name}
              </small>
              {participant.orcid && (
                <a
                  href={participant.orcid}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ms-1"
                >
                  <img src={orcid} alt="ORCID" />
                </a>
              )}
            </span>
            {index < self.length - 1 && <span className="text-muted">;</span>}
          </Col>
        ))}
      </Row>
    </Col>
  );
}
